<template>
  <div class="col-lg-8">
    <div class="row">
      <div class="col-12">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header">
            <h4 class="title">Notificações por WhatsApp</h4>
          </div>
          <div class="dash-pro-body">
            <p class="mb-4">
              Receba notificações sobre lances, faturas, habilitação e outras atualizações
              diretamente no seu WhatsApp.
            </p>
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <p class="mb-0 text-muted">
                  Receber notificações por WhatsApp
                </p>
              </div>
              <label class="switch"
                :title="this.recebeWhatsApp ? 'Desativar notificações por WhatsApp' : 'Ativar notificações por WhatsApp'">
                <input type="checkbox" v-model="recebeWhatsApp" @change="salvar" :disabled="salvando" />
                <span class="slider round"></span>
              </label>
            </div>
            <div v-if="salvando" class="mt-3">
              <i class="fa fa-spin fa-spinner mr-1"></i> Salvando...
            </div>
            <div v-if="mensagemSucesso" class="mt-3 text-success">
              <i class="fa fa-check-circle mr-1"></i> {{ mensagemSucesso }}
            </div>
            <div v-if="mensagemErro" class="mt-3 text-danger">
              <i class="fa fa-times-circle mr-1"></i> {{ mensagemErro }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import http from '@/service/http/http';
import Notification from '@/mixins/notification';

export default {
  name: 'Notificacoes',
  mixins: [Notification],
  data() {
    return {
      recebeWhatsApp: false,
      salvando: false,
      mensagemSucesso: '',
      mensagemErro: '',
    };
  },
  computed: {
    ...mapGetters(['getUsuarioInfo', 'getAuth']),
  },
  watch: {
    getUsuarioInfo(val) {
      if (val && val.recebeWhatsApp !== undefined) {
        this.recebeWhatsApp = val.recebeWhatsApp;
      }
    },
  },
  async created() {
    await this.info();
    this.recebeWhatsApp = !!this.getUsuarioInfo?.recebeWhatsApp;
  },
  methods: {
    ...mapActions(['info']),
    async salvar() {
      this.salvando = true;
      this.mensagemSucesso = '';
      this.mensagemErro = '';
      const payload = {
        recebeWhatsApp: this.recebeWhatsApp,
      };
      try {
        await http.put('usuario/Notificacoes/WhatsApp', payload);
        this.mensagemSucesso = 'Preferência salva com sucesso';
        this.showToast({ title: 'Notificação atualizada com sucesso' });
      } catch (_) {
        this.recebeWhatsApp = !this.recebeWhatsApp;
        this.mensagemErro = 'Erro ao salvar. Tente novamente.';
        this.showAlert({
          type: 'error',
          title: 'ATENÇÃO',
          message: 'Erro ao atualizar a notificação',
        });
      }
      this.salvando = false;
    },
  },
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #0783ae;
}

input:checked+.slider:before {
  transform: translateX(24px);
}

.slider.round {
  border-radius: 28px;
}

.text-muted {
  color: #6c757d;
  font-size: 0.9rem;
}
</style>
